import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'assistant/:url',
  async getComponent (nextState) {
    const {
      default: AssistantContainer
    } = await import(/* webpackChunkName: "assistant-container" */ './containers/AssistantContainer.tsx')
      .catch(handleChunkLoadError);
    return AssistantContainer;
  },
  getData ({ params, context }) {
    return context.props;
  }
});
